import { EntitySelectorsFactory } from '@ngrx/data';
import { Especie } from './especies.model';

export const especiesSelectors =
  new EntitySelectorsFactory().create<Especie>('Especie');

export const selectAllEspecies = especiesSelectors.selectEntities;